import React from 'react';
import Icon from '@/components/ui/AppIcon';

interface EmptyStateProps {
  icon: string;
  title: string;
  description: string;
  actionLabel?: string;
  onAction?: () => void;
  actionHref?: string;
}

export default function EmptyState({ icon, title, description, actionLabel, onAction, actionHref }: EmptyStateProps) {
  return (
    <div className="flex flex-col items-center justify-center py-16 px-6 text-center">
      <div className="w-16 h-16 rounded-2xl bg-muted/50 flex items-center justify-center mb-4">
        <Icon name={icon as Parameters<typeof Icon>[0]['name']} size={28} className="text-muted-foreground" />
      </div>
      <h3 className="text-base font-semibold text-foreground mb-2">{title}</h3>
      <p className="text-sm text-muted-foreground max-w-xs mb-6">{description}</p>
      {actionLabel && (actionHref ? (
        <a
          href={actionHref}
          className="px-4 py-2 rounded-lg text-sm font-semibold text-white gradient-primary hover:opacity-90 active:scale-95 transition-all duration-150"
        >
          {actionLabel}
        </a>
      ) : (
        <button
          onClick={onAction}
          className="px-4 py-2 rounded-lg text-sm font-semibold text-white gradient-primary hover:opacity-90 active:scale-95 transition-all duration-150"
        >
          {actionLabel}
        </button>
      ))}
    </div>
  );
}